import React, { useState } from "react";
import { ResponsiveContainer, BarChart, Bar, Cell, Tooltip } from "recharts";
import PropTypes from "prop-types";
import "./SummaryBarTile.scss";
import { chartColors, defaultLineProps, tooltipContentStyle, tooltipItemStyle, tooltipLabelStyle } from "./ChartStyles";

const SummaryBarTile = ({
  title = "Last Month Sales",
  data = [],
  valueKey = "value",
  labelKey = "month",
  amountKey = "amount",
  changeKey = "change",
  highlightColor = "#F3722C",
  baseColor = "#CDECE7",
  positiveColor = "#1dbf73",
  negativeColor = "#d9534f",
  subtitle = "Last 6 month Total Sales",
}) => {
  const defaultMonth = data.length ? data[data.length - 1][labelKey] : null;
  const [selectedLabel, setSelectedLabel] = useState(defaultMonth);

  const selected = data.find((d) => d[labelKey] === selectedLabel) || {};

  const handleBarClick = (entry) => {
    setSelectedLabel(entry[labelKey]);
  };

  const isPositive = selected[changeKey]?.startsWith("+");

  return (
    <div
      className="summary-bar-tile d-flex justify-content-between align-items-center p-4"
      style={{ height: `100%`, width: `100%` }}
    >
      {/* Left Side - Summary */}
      <div className="tile-summary text-start">
        <h6 className="tile-title">{selectedLabel ? `${selectedLabel} ${title.split(" ")[1]}` : title}</h6>
        <div className="tile-value d-flex align-items-center">
          <h3 className="me-2 mb-0">
            {selected[amountKey] !== undefined ? `$${selected[amountKey].toFixed(2)}` : "$0.00"}
          </h3>
          {selected[changeKey] && (
            <span className={`tile-badge ${isPositive ? "increase" : "decrease"}`}>
              <i className={`bi ${isPositive ? "bi-graph-up" : "bi-graph-down"}`}></i> {selected[changeKey]}
            </span>
          )}
        </div>
        <p className="tile-subtitle mb-0">{subtitle}</p>
      </div>

      {/* Right Side - Chart */}
      <div className="tile-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} isAnimationActive={false} >
            <Tooltip
              formatter={(value, name, props) => [`$${props.payload[amountKey]}`, "Sales"]}
              labelFormatter={(label) => `Month: ${label}`}
              contentStyle={tooltipContentStyle}
              itemStyle={tooltipItemStyle}
              labelStyle={tooltipLabelStyle}
            />
            <Bar
              dataKey={valueKey}
              radius={[4, 4, 0, 0]}
              onClick={handleBarClick}
              cursor="pointer"
              isAnimationActive={false}
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry[labelKey] === selectedLabel ? highlightColor : baseColor}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

SummaryBarTile.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  amountKey: PropTypes.string,
  changeKey: PropTypes.string,
  highlightColor: PropTypes.string,
  baseColor: PropTypes.string,
  subtitle: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default SummaryBarTile;
